import { render, staticRenderFns } from "./LandingStatistiques.vue?vue&type=template&id=afc4b204&scoped=true"
import script from "./LandingStatistiques.vue?vue&type=script&lang=js"
export * from "./LandingStatistiques.vue?vue&type=script&lang=js"
import style0 from "./LandingStatistiques.vue?vue&type=style&index=0&id=afc4b204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4b204",
  null
  
)

export default component.exports